import './styles.scss'

import { WarningIcon } from './_resources/WarningIcon';
import { setupNetwork } from '../../../utils/setupNetwork';

type Props = {
  text?: string
}

const OnlyBSCModal = ({text}: Props) => {
  return (
    <div className="only-bsc-modal g-modal">
      <div className="g-modal__bg"/>
      <div className="g-modal__card card">
        <div className="card__top">
          <div className="title-with-icon">
            <WarningIcon />
            <h2 className="title-text">Warning</h2>
          </div>
        </div>
        <div className="card__content only-bsc-modal__content">
          <h3 className="only-bsc-modal__text">
            {
              text ||
              <span className="default-text">
                The current page requires the use of the <span className="highlight-red">BSC Mainnet network.</span>
                <br />
                Please switch networks in Metamask and refresh this page.
              </span>
            }
          </h3>
          <div className="switch-btn-wrapper">
            <button onClick={() => { setupNetwork("bsc") }} className="card__button small">Switch</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OnlyBSCModal
